module.exports = __webpack_public_path__ + "img/server-white.dc19418b.svg";